import React from 'react'
import { Box, Grid, Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { SearchForm } from './components'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
  imageCoverContainer: {
    height: 300,
    width: '100%',
    backgroundImage:
      'url(https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/NCH.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  container: {
    maxWidth: 1280,
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10
  },
  inImageTitleContainer: {
    marginTop: 60,
    [theme.breakpoints.down('sm')]: {
      marginTop: 90
    }
  },
  inImageTitle: {
    display: 'block',
    fontWeight: 500,
    fontSize: 36,
    lineHeight: 1.35,
    textAlign: 'center',
    color: 'white'
  },
  inImageSubtitle: {
    display: 'block',
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '28px',
    color: 'white'
  },
  inImageInputContainer: {
    marginTop: 60
  },
  outImageInputcontainer: {
    margin: '24px 10px 10px'
  }
}))

const HeroAndSearchForm = props => {
  const { className, ...rest } = props
  const classes = useStyles()

  const { heroTitle } = useSelector(state => state.language.text)

  return (
    <>
      <Box className={classes.imageCoverContainer}>
        <Grid container justify="center" spacing={0}>
          <Grid item className={classes.container}>
            <Grid container alignItems="center" justify="center" spacing={0}>
              <Grid item className={classes.inImageTitleContainer} xs={12}>
                <span className={classes.inImageTitle}>{heroTitle}</span>
              </Grid>
            </Grid>
            <Hidden smDown>
              <Box className={classes.inImageInputContainer}>
                <SearchForm />
              </Box>
            </Hidden>
          </Grid>
        </Grid>
      </Box>
      <Hidden mdUp>
        <Box className={classes.outImageInputcontainer}>
          <SearchForm className={classes.outImageInputcontainer} />
        </Box>
      </Hidden>
    </>
  )
}

export default HeroAndSearchForm
